$(function () {
	var shareTextTwitter = "ウォーキングシューズのパイオニア「ムーンスターワールドマーチ」から透湿防水モデル登場!!歩き続けるというプライド";
	var shareTextLine = "";
	var sahreUrl = "http://www.moonstar.co.jp/worldmarch/pride/";

	// twitter
	(function(){
		var shareText = shareTextTwitter;
		var apiUrl = "https://twitter.com/share?";
		var params = [];
		params.push("text=" + encodeURIComponent(shareText));
		params.push("url=" + encodeURIComponent(sahreUrl));
		$('.js-share-twitter').attr('href', apiUrl + params.join("&")).prop('target','_blank')
		.on('click', function(){
			popup(apiUrl + params.join("&"));
			return false;
		});
	})();

	// facebook
	(function(){
		var apiUrl = "https://www.facebook.com/share.php?";
		var params = [];
		params.push("u=" + encodeURIComponent(sahreUrl));
		$('.js-share-facebook').attr('href', apiUrl + params.join("&")).prop('target','_blank')
		.on('click', function(){
			popup(apiUrl + params.join("&"));
			return false;
		});
	})();


	// google plus
	(function(){
		var apiUrl = "https://plus.google.com/share?";
		var params = [];
		params.push("url=" + encodeURIComponent(sahreUrl));
		$('.js-share-google-plus').attr('href', apiUrl + params.join("&")).prop('target','_blank')
		.on('click', function(){
			popup(apiUrl + params.join("&"));
			return false;
		});
	})();


	// line
	(function(){
		var shareText = shareTextLine || shareTextTwitter;
		var apiUrl = "http://line.me/R/msg/text/?";
		$('.js-share-line').attr('href', apiUrl + encodeURIComponent(shareText + " " + sahreUrl));
	})();

	var popwin = null;
	function popup(url){
		if( popwin !== null ) popwin.close();
		popwin = window.open(url, 'shareWindow', 'width=550, height=450,personalbar=0,toolbar=0,scrollbars=1,resizable=1');
	}

});